import Image from 'next/image';

import { FOOTER_CONFIG } from '@eliadmin/core/src/constants/footer-config';
import { Paragraph } from '../../ui/paragraph';

export function ProductPaymentMethods() {
  return (
    <div className="flex w-full flex-wrap items-center justify-center gap-2">
      <div className="flex items-center justify-center gap-2">
        {FOOTER_CONFIG?.payment_methods?.map(method => (
          <Image
            key={method?.name}
            src={method?.icon}
            alt={method?.name}
            width={54}
            height={28}
            className="shrink-0 object-contain object-center"
          />
        ))}
      </div>
      <div className="flex items-center justify-center gap-2">
        <Image
          src={'/images/icons/lock-password-foreground.svg'}
          alt="Záruka bezpečného nákupu"
          width={16}
          height={16}
          className="shrink-0"
        />
        <Paragraph size="base" color="muted-foreground">
          Záruka bezpečného nákupu
        </Paragraph>
      </div>
    </div>
  );
}
